// 管理者のメールアドレスリスト
export const ADMIN_EMAILS: string[] = [
  'sonnabanana877@gmail.com',
  'd.d.y.saito@gmail.com',
  'ksta877@gmail.com',
];

// 管理者のUIDリスト（オプション）
export const ADMIN_UIDS: string[] = [
  'RO8LWLbJrOamXc7cW55R69pSZRw2',
  'g7YMR6H8OpayGpID65HZvCGYJ5u2',
  'kGsoPEbQ0YYbErXE3W0KYr9i2Ex1',
];

/**
 * ユーザーが管理者かどうかをチェック
 */
export const isAdmin = (email: string | null, uid: string | null): boolean => {
  if (!email && !uid) return false;

  const emailCheck = email ? ADMIN_EMAILS.includes(email) : false;
  const uidCheck = uid ? ADMIN_UIDS.includes(uid) : false;

  return emailCheck || uidCheck;
};
